var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownSignToNavigate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-sign-to-navigate",
    clipPath: "url(#clip0_1_7225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1",
    d: "M9.03819 7.91939C9.03819 7.63553 8.92969 7.3517 8.71314 7.13527L1.89548 0.32492C1.4618 -0.108307 0.758642 -0.108307 0.325128 0.32492C-0.108376 0.757974 -0.108376 1.46024 0.325128 1.8935L6.35777 7.91939L0.325341 13.9453C-0.108173 14.3785 -0.108173 15.0807 0.325341 15.5138C0.758856 15.9472 1.462 15.9472 1.8957 15.5138L8.71337 8.7035C8.92994 8.48697 9.03819 8.20315 9.03819 7.91938V7.91939Z",
    fill: "#00B383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9,
    fill: "white",
    transform: "matrix(0 1 1 0 0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSignToNavigate);
export default __webpack_public_path__ + "static/media/arrow-down-sign-to-navigate.64800b53406b668ae6ab6cdcdde194a9.svg";
export { ForwardRef as ReactComponent };